<script>
    import FilterEditObject from '@/components/page-filter-edit/FilterEditObject.vue';
    import FilterItemEditObject from '@/components/page-filter-edit/FilterItemEditObject.vue';

    export default {
        props: {
            filter: Object,
        },
        components: {
            FilterEditObject: FilterEditObject,
            FilterItemEditObject: FilterItemEditObject,
        },
        methods: {
            async selectFilter() {
                this.$store.commit('FILTER_DATA_EDIT_SET', this.filter);
                this.$store.dispatch('CHECK_FILTER_EDIT');
                this.$store.commit('IS_SHOW_FILTER_EDIT', true)
            }
        }
    }
</script>


<template>
    <div 
        class="right_header cursor_pointer_label"
        @click="selectFilter"
    >
        <label>[{{ filter['id'] }}]</label>
        <label
            class="ml_5"
        >{{ filter['name'] }}</label>
    </div>
    <ul
        class="clear_ul"
        v-if="filter['children_filter'] == null"
    >
        <FilterItemEditObject 
            v-for="(filterItemValue, filterItemIndex) in filter['filter_items']" :key="filterItemIndex"
            :filterItem="filterItemValue"
            :assetTypeID="filter['asset_type_id']"
        />
    </ul>
    <div 
        v-else
        class="border_sub_container"
    >
        <FilterEditObject 
            v-for="(filterValue, filterIndex) in filter['children_filter']" :key="filterIndex"
            :filter = "filterValue"
        />
    </div>
</template>